<ng-container *ngIf="showContent" [ngSwitch]="type">
  <ng-container *ngSwitchCase="'card'">
    <div class="skeleton-card-grid" role="status" [attr.aria-label]="ariaLabel" aria-busy="true">
      <div class="skeleton-card {{animation}}-card" *ngFor="let row of rowsArr">
        <div class="skeleton-card-header">
          <div class="skeleton-cell {{animation}}-cell h-20 w-65" role="presentation"></div>
          <div class="skeleton-cell {{animation}}-cell skeleton-pill w-80" role="presentation"></div>
        </div>
        <div class="skeleton-card-body">
          <div class="skeleton-cell {{animation}}-cell h-14 w-100" role="presentation"></div>
          <div class="skeleton-cell {{animation}}-cell h-14 w-70" role="presentation"></div>
          <div class="skeleton-cell {{animation}}-cell h-14 w-50" role="presentation"></div>
        </div>
        <div class="skeleton-card-actions">
          <div class="skeleton-cell {{animation}}-cell h-36 w-120" role="presentation"></div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'data-table'">
    <div class="skeleton-dt" role="status" [attr.aria-label]="ariaLabel" aria-busy="true">
      <div class="skeleton-dt-header">
        <div
          class="skeleton-dt-header-cell {{animation}}-dt-header-cell"
          *ngFor="let col of columns"
          [style.width]="col.width"
          [style.min-width]="col.minWidth"
          role="presentation"
        ></div>
      </div>
      <div
        class="skeleton-dt-row {{animation}}-dt-row"
        *ngFor="let row of rowsArr; let ri = index"
        [style.animation-delay]="(ri % 3) * 0.12 + 's'"
      >
        <div
          class="skeleton-dt-cell {{animation}}-dt-cell"
          *ngFor="let col of columns; let ci = index"
          [style.width]="col.width"
          [style.min-width]="col.minWidth"
          [style.animation-delay]="(ri * columns.length + ci) * 0.03 + 's'"
          role="presentation"
        ></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'input-row'">
    <div class="sk-input-rows" role="status" [attr.aria-label]="ariaLabel" aria-busy="true">
      <div class="sk-input-row" *ngFor="let row of rowsArr; let ri = index" [style.animation-delay]="(ri % 3) * 0.15 + 's'">
        <div class="sk-input-circle {{animation}}-input-circle" role="presentation"></div>
        <div class="sk-input-line {{animation}}-input-line sk-input-line-lg" role="presentation"></div>
        <div class="sk-input-line {{animation}}-input-line sk-input-line-sm" role="presentation"></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'custom'">
    <ng-content></ng-content>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <div class="skeleton-table" role="status" [attr.aria-label]="ariaLabel" aria-busy="true">
      <div class="skeleton-header">
        <div
          class="skeleton-header-cell"
          *ngFor="let col of columns; let i = index"
          [style.width]="col.width"
          [style.min-width]="col.minWidth"
          [style.height]="col.height || '14px'"
          [class.skeleton-header-cell-center]="i === 0"
          role="presentation"
        ></div>
      </div>
      <div
        class="skeleton-row {{animation}}-row"
        *ngFor="let row of rowsArr; let ri = index"
        [style.animation-delay]="(ri % 3) * 0.15 + 's'"
      >
        <div
          class="skeleton-cell {{animation}}-cell"
          [class.skeleton-cell-circle]="col.circle"
          *ngFor="let col of columns; let ci = index"
          [style.width]="col.width"
          [style.min-width]="col.minWidth"
          [style.height]="col.height || '16px'"
          [style.animation-delay]="(ri * columns.length + ci) * 0.03 + 's'"
          role="presentation"
        ></div>
      </div>
    </div>
  </ng-container>
</ng-container>
